export const SC_IDS_WITH_SUBSCRIPTION_TOGGLE = [
    10, 16, 25, 50, 51, 53, 55, 65, 67, 69, 73, 77, 78, 91, 99, 108, 114, 139, 140, 148, 149, 154, 155, 163, 327, 329,
    333, 384, 390, 421, 441, 447, 456,
];
